<template>
  <section class="ead-page">    
    <header class="box ead-hero">
      <div>
        <p class="ead-eyebrow">Acompanhamento de treinamentos</p>
        <h1 class="title is-4 mb-2">Relatório de progresso</h1>        
      </div>
      <div class="total-registros">
        <strong>{{ dados.total || 0 }}</strong>
        <span>{{ (dados.total || 0) === 1 ? 'registro' : 'registros' }}</span>
      </div>
    </header>

    <div class="box relatorio-card">
      <b-table
        :data="dados.lista || []"
        :loading="loading"
        :mobile-cards="true"
        hoverable
        paginated
        backend-pagination
        :total="dados.total || 0"
        :per-page="20"
        @page-change="carregar"
      >
        <b-table-column label="Funcionário" field="funcionario" v-slot="p">
          <strong>{{ p.row.funcionario }}</strong>
        </b-table-column>
        <b-table-column label="Curso" field="curso" v-slot="p">{{ p.row.curso }}</b-table-column>
        <b-table-column label="Progresso" v-slot="p">
          <div class="progresso-celula"><ead-progresso :valor="p.row.progresso" /></div>
        </b-table-column>
        <b-table-column label="Nota" v-slot="p">
          {{ p.row.notaFinal == null ? '—' : p.row.notaFinal }}
        </b-table-column>
        <b-table-column label="Status" v-slot="p">
          <b-tag rounded :type="p.row.atrasado ? 'is-danger' : tipoStatus(p.row.status)">
            {{ p.row.atrasado ? 'Atrasado' : p.row.status }}
          </b-tag>
        </b-table-column>
        <b-table-column label="Ações" centered v-slot="p">
          <router-link class="button is-small is-primary is-light" :to="{ name: 'ead-progresso-detalhe', params: { id: p.row.id } }">
            <b-icon icon="eye-outline" size="is-small" /><span>Ver detalhes</span>
          </router-link>
        </b-table-column>
        <template slot="empty">
          <div v-if="!loading" class="ead-empty">
            <b-icon :icon="erro ? 'alert-circle-outline' : 'clipboard-text-outline'" size="is-medium" />
            <p class="has-text-weight-semibold">{{ erro ? 'Não foi possível carregar o relatório' : 'Nenhum progresso encontrado' }}</p>
            <p class="is-size-7 mt-1 mb-3">{{ erro ? 'Verifique sua conexão e tente novamente.' : 'As liberações da unidade aparecerão aqui.' }}</p>
            <b-button v-if="erro" icon-left="refresh" @click="carregar(1)">Tentar novamente</b-button>
          </div>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import http from '@/http'
import EadProgresso from '@/components/ead/ead-progresso.vue'
import { mapState } from 'vuex'

export default {
  name: 'EadRelatorioProgresso',
  components: { EadProgresso },
  data: () => ({ dados: { lista: [], total: 0 }, loading: false, erro: false }),
  computed: { ...mapState(['unidadeId']) },
  watch: { unidadeId() { this.carregar(1) } },
  mounted() { this.carregar(1) },
  methods: {
    tipoStatus(status) {
      if (status === 'Concluído' || status === 'Concluido') return 'is-success'
      if (status === 'Em andamento') return 'is-info'
      return 'is-light'
    },
    carregar(page) {
      this.loading = true
      this.erro = false
      http.get('/api/ead-relatorios/progresso', {
        params: { unidadeId: this.unidadeId, page, perPage: 20 },
      })
        .then((r) => { this.dados = r.data || { lista: [], total: 0 } })
        .catch(() => { this.dados = { lista: [], total: 0 }; this.erro = true })
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style scoped>
.relatorio-card { overflow: hidden; padding: 0.75rem; }
.total-registros { align-items: baseline; background: #e8f5f1; border-radius: 12px; color: #087462; display: flex; gap: 0.45rem; padding: 0.65rem 1rem; white-space: nowrap; }
.total-registros strong { font-size: 1.4rem; }
.total-registros span { font-size: 0.85rem; font-weight: 600; }
.progresso-celula { min-width: 130px; }
</style>
